import React from "react";
import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./style.css";

const VehicleLimitModal = ({
  open,
  onCancel,
  onPurchase,
  vehicleCount = 0, // Dynamic: defaults to 0 if blank
  limitMax = 0, // Dynamic: passed down from parent config
  planName = "Pro Plan", // Dynamic: customizable plan name
  priceLabel = "$8/month", // Dynamic: customizable rate label
}) => {
  const percentage =
    limitMax > 0 ? Math.min((vehicleCount / limitMax) * 100, 100) : 0;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      className="confirm-modal limit-modal"
    >
      <div className="top-gradient"></div>
      <div className="limit-modal-body">
        <div className="limit-header">
          <div className="limit-icon-wrapper">
            <ExclamationCircleOutlined className="limit-icon" />
          </div>
          <div className="limit-title-container">
            <div className="limit-title">Vehicle Limit Reached</div>
            <div className="limit-subtitle">
              You have reached your subscription limit of {limitMax || "—"}{" "}
              vehicles.
            </div>
          </div>
        </div>

        <div className="plan-details-card">
          <div className="plan-row">
            <div>
              <div className="plan-label">Current Plan</div>
              <div className="plan-value">{planName}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div className="plan-label">Price Per Vehicle</div>
              <div className="plan-value">{priceLabel}</div>
            </div>
          </div>

          <div className="plan-row" style={{ marginBottom: 0 }}>
            <div>
              <div className="plan-label">Vehicles Allowed</div>
              <div className="plan-value">{limitMax || "—"}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div className="plan-label">Vehicles In Use</div>
              <div className="plan-value">
                <span className="badge-count">{vehicleCount}</span>
              </div>
            </div>
          </div>

          <div className="capacity-container">
            <div className="capacity-header">
              <span className="plan-label">Capacity Utilization</span>
              <span className="capacity-text">
                {vehicleCount} / {limitMax || "0"} USED
              </span>
            </div>
            <div className="custom-progress-bar">
              <div
                className="custom-progress-fill"
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
          </div>
        </div>

        <div className="limit-buttons">
          <Button className="btn-cancel-light" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="btn-purchase-seats" onClick={onPurchase}>
            Purchase More Seats
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VehicleLimitModal;
